/*
 * BUDCADE - Dots for Dawn's store rows (slider-component) on phones.
 * File   : assets/budcade-slider-dots.js
 * Loaded : layout/theme.liquid, deferred, right after budcade-site.css.
 * Adds a row of dots under each product slider (one per card), marks the
 * card in view, and lets the CSS (assets/budcade-site.css, "Store rows")
 * hide Dawn's arrows and "1 / 8" counter on phones. Desktop is unchanged.
 */
(function () {
  function setup(slider) {
    if (slider.classList.contains('bc-has-dots')) return;
    var track = slider.querySelector('.slider');
    if (!track) return;
    var items = track.querySelectorAll('.slider__slide');
    if (items.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'bc-slider-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < items.length; i++) dots.appendChild(document.createElement('span'));
    slider.appendChild(dots);
    slider.classList.add('bc-has-dots');

    var spans = dots.children;
    function update() {
      var left = track.getBoundingClientRect().left;
      var active = 0;
      var best = Infinity;
      for (var j = 0; j < items.length; j++) {
        var d = Math.abs(items[j].getBoundingClientRect().left - left);
        if (d < best) {
          best = d;
          active = j;
        }
      }
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) active = items.length - 1;
      for (var k = 0; k < spans.length; k++) spans[k].classList.toggle('is-active', k === active);
    }
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(function (s) {
      if (s.querySelector('.slider--mobile, .slider--tablet')) setup(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
